module.exports = __webpack_public_path__ + "img/inbox.485a3ef7.svg";